// external imports
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';

// internal imports
import './index.css';
import App from './App';
import config from './config';
import { PipelineProvider } from './contexts/pipelineContext';

require('leaflet');

Amplify.configure({
	Auth: {
		mandatorySignIn: false,
		region: config.cognito.REGION,
		userPoolId: config.cognito.USER_POOL_ID,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
		userPoolWebClientId: config.cognito.APP_CLIENT_ID,
		authenticationFlowType: config.cognito.AuthenticationFlowType,
		storage: sessionStorage
	},
	API: {
		endpoints: [
			{
				name: config.qcApi.NAME,
				endpoint: config.qcApi.URL,
				region: config.qcApi.REGION,
				authorizationType: 'AMAZON_COGNITO_USER_POOLS'
			},
			{
				name: config.gainsApi.NAME,
				endpoint: config.gainsApi.URL,
				region: config.gainsApi.REGION,
				authorizationType: 'AMAZON_COGNITO_USER_POOLS'
			}
		]
	},
	Storage: {
		AWSS3: {
			bucket: 'gains-qc-development',
			region: 'eu-west-2',
			identityPoolId: config.cognito.IDENTITY_POOL_ID
		}
	}
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<PipelineProvider>
		<App />
	</PipelineProvider>
);
